import React from 'react';
import { Input } from './ui/input';

// Format a string with custom group sizes, defaulting to groups of 4
const formatWithGroups = (str, groups) => {
  if (!groups || groups.length === 0) return str.replace(/(.{4})/g, '$1 ').trim();
  let result = '';
  let pos = 0;
  for (let i = 0; i < groups.length && pos < str.length; i++) {
    if (i > 0) result += ' ';
    result += str.substring(pos, pos + groups[i]);
    pos += groups[i];
  }
  // Any remaining chars in groups of 4
  while (pos < str.length) {
    result += ' ' + str.substring(pos, pos + 4);
    pos += 4;
  }
  return result.trim();
};

// Remove spaces from formatted string
const stripSpaces = (str) => str.replace(/\s/g, '');

export const FormattedInput = ({
  prefix,
  value,
  onChange,
  numDigits,
  numLetters = 0,
  placeholder,
  groups,
  id,
  'data-testid': testId,
}) => {
  const raw = (value || '').replace(new RegExp(`^${prefix}`), '');
  const clean = stripSpaces(raw);

  // Format for display
  const displayed = formatWithGroups(clean, groups);

  const handleChange = (e) => {
    let input = stripSpaces(e.target.value);

    // Separate digit part and letter part
    let digits = '';
    let letters = '';

    for (let i = 0; i < input.length && digits.length < numDigits; i++) {
      if (/\d/.test(input[i])) digits += input[i];
    }

    if (numLetters > 0) {
      const letterPart = input.substring(digits.length);
      for (let i = 0; i < letterPart.length && letters.length < numLetters; i++) {
        if (/[a-zA-Z]/.test(letterPart[i])) letters += letterPart[i].toUpperCase();
      }
    }

    const combined = digits + letters;
    onChange(prefix + combined);
  };

  const maxDisplay = numDigits + numLetters + Math.floor((numDigits + numLetters - 1) / 4);

  return (
    <div className="flex">
      <span className="inline-flex items-center px-3 bg-slate-100 border border-r-0 border-slate-200 rounded-l-lg text-sm font-mono font-semibold text-slate-600 whitespace-nowrap">
        {prefix}
      </span>
      <Input
        id={id}
        value={displayed}
        onChange={handleChange}
        maxLength={maxDisplay}
        placeholder={placeholder}
        className="h-11 rounded-l-none rounded-r-lg font-mono tracking-wider"
        data-testid={testId}
      />
    </div>
  );
};
